import styled from 'styled-components';

export const Container = styled.div`
  gap: 32px;
  margin: 32px 0;
  min-width: 1250px;

  display: flex;
  flex-direction: column;
`;
